// extracted by mini-css-extract-plugin
export var copyright = "copyright-module--copyright--2537c";
export var download = "copyright-module--download--21e76";
export var homepagelink = "copyright-module--homepagelink--a0b5e";